import React, { PureComponent } from 'react'
import { bool } from 'prop-types'
import cn from 'classnames'
import { FieldInputProps } from 'react-final-form'

import { PROP_TYPE_INPUT } from '../Forms/constants'
import { getState } from '../Forms/utils'

const TEXT_AREA_MIN_HEIGHT = 120

export type TextareaProps = Partial<FieldInputProps<string>>

export default class Textarea extends PureComponent<TextareaProps> {
  static propTypes = {
    ...PROP_TYPE_INPUT,
    autoResize: bool,
  }

  static defaultProps = {
    value: '',
    autoResize: false,
  }

  private input: React.RefObject<HTMLTextAreaElement>

  constructor(props: TextareaProps) {
    super(props)

    this.input = React.createRef()
  }

  state = {
    focused: false,
  }

  checkResize = () => {
    const { autoResize } = this.props

    if (autoResize) {
      this.resize()
    }
  }

  componentDidMount() {
    this.checkResize()
  }

  componentDidUpdate() {
    this.checkResize()
  }

  onFocus = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    const { onFocus } = this.props

    this.setState({ focused: true })

    if (onFocus) {
      onFocus(event)
    }
  }

  onBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    const { onBlur } = this.props

    this.setState({ focused: false })

    if (onBlur) {
      onBlur(event)
    }
  }

  onInput = () => {
    this.checkResize()
  }

  focus = () => {
    this.input.current?.focus()
  }

  resize = () => {
    const element = this.input.current

    if (element?.scrollHeight) {
      element.style.minHeight = `${TEXT_AREA_MIN_HEIGHT}px`
      element.style.height = `${element.scrollHeight}px`
    }
  }

  render() {
    const {
      disabled,
      error,
      label,
      name,
      success,
      touched,
      value,
      onChange,
      className,
      autoResize,
      ...props
    } = this.props

    const { focused } = this.state

    const state = getState({ error, success, touched })
    const classes = cn({
      'mc-form-textarea': true,
      'mc-form-element': true,
      'mc-form-element--disabled': disabled,
      'mc-form-element--focus': focused,
      [`mc-form-element--${state}`]: state,
    })

    return (
      <div className={classes}>
        <textarea
          ref={this.input}
          name={name}
          id={name}
          className={cn('mc-form-element__element', className)}
          value={value}
          disabled={disabled}
          {...props}
          onChange={onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onInput={this.onInput}
          aria-invalid={!!error}
        />
      </div>
    )
  }
}
